//App.vue
<template>
  <div id="app">
    <Navbar :screenWidth="screenWidth" @ontabBar="ontabBar" id="Navbar" />
    <Container id="Container" />
    <ProductCenter id="ProductCenter" />
    <AboutUs id="AboutUs" />
    <CooperativeAlliance id="CooperativeAlliance" />
    <MyTeam id="MyTeam" />
    <NewsCenter id="NewsCenter" />
    <Bottom id="Bottom" />
  </div>
</template>
<script>
export default {
  data() {
    return {
      screenWidth: document.body.clientWidth,
    };
  },
  components: {
    Navbar: () => import("./components/Navbar.vue"),
    Container: () => import("./components/Container.vue"),
    ProductCenter: () => import("./components/ProductCenter.vue"),
    AboutUs: () => import("./components/AboutUs.vue"),
    CooperativeAlliance: () => import("./components/CooperativeAlliance.vue"),
    MyTeam: () => import("./components/MyTeam.vue"),
    NewsCenter: () => import("./components/NewsCenter.vue"),
    Bottom: () => import("./components/Bottom.vue"),
  },
  mounted() {
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth;
        this.screenWidth = window.screenWidth;
      })();
    };
  },
  methods: {
    ontabBar(e) {
      document.getElementById(e).scrollIntoView(true);
    },
  },
};
</script>

<style lang="less">
div,
ul,
li {
  padding: 0;
  margin: 0;
}
body .max_titel {
  text-align: center;
  font-weight: 400;
  div:nth-child(1) {
    font-size: 24px;
    color: #333333;
  }
  div:nth-child(2) {
    font-size: 14px;
    color: #666666;
    font-weight: 400;
    letter-spacing: 0.25rem;
  }
  div:nth-child(3) {
    width: 32px;
    height: 5px;
    background: #ef7133;
    margin: 5px auto 50px auto;
    border-radius: 10px;
  }
}
</style>


// WEBPACK FOOTER //
// src/App.vue